<form [formGroup]="tenantDetailsFormGroup">
  <mat-form-field class="form-input">
    <input
      matInput
      placeholder="Tenant name"
      formControlName="name"
      (keyUp)="onNameChange($event)"
    />
  </mat-form-field>

  <mat-form-field class="form-input">
    <input
      matInput
      placeholder="Organization Id"
      formControlName="organizationId"
      (key)="onOrganizationIdChange($event)"
    />
  </mat-form-field>

  <div class="row">
    <og-input-details-list
      class="container__card"
      [title]="'Permissions'"
      [list]="permissions"
      [theme]="'primary'"
      [size]="'size'"
      (listChange)="permissions = $event"
    ></og-input-details-list>

    <og-input-details-list
      class="container__card"
      [title]="'Email Domains'"
      [list]="emailDomains"
      [theme]="'primary'"
      [size]="'size'"
      (listChange)="emailDomains = $event"
    ></og-input-details-list>
  </div>

  <div class="buttons-container">
    <button mat-raised-button color="accent" (click)="onCancelClicked()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmitClick()">
      <i class="material-icons">merge_type</i>
      Submit
    </button>
  </div>
</form>
